import React from 'react'
import Link from 'gatsby-link'
import Logo from '../ww-logo'
import Bus from '../../utils/bus'
import ClassNames from 'classnames'
let BUS = new Bus()

import Cart from './cart'

class CartOpen extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
    }
    this.close = this.close.bind(this)
    this.open = this.open.bind(this)
  }

  componentDidMount() {
    BUS.listen('OPEN_CART', this.open)
    BUS.listen('OPEN_NAV', this.close)
    BUS.listen('CLOSE_CART', this.close)
  }

  open() {
    this.setState({
      open: true,
    })
  }

  close(event) {
    this.setState({
      open: false,
    })
  }

  render() {
    return (
      <div
        className={ClassNames({
          NavOpen: true,
          'is-actually-open-tho': this.state.open,
        })}
      >
        <div className="bg" onClick={this.close} />
        <div className="items">
          <Cart location={this.props.location} />
        </div>
        <button className="close cart" onClick={this.close}>
          <span>&times;</span>
        </button>
      </div>
    )
  }
}

export default CartOpen



// WEBPACK FOOTER //
// ./src/components/cart/cart-open.js